import React from 'react';

const Tbody = ({ children, ...props }) => {
  return (
    <tbody {...props}>
      {children}
    </tbody>
  );
};

export default Tbody;
